import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import contactApi, { ContactData } from '../apis/contact.api'
import confirmService from '../services/confirm.service'
import contactService from '../services/contact.service'
import { ConfirmParams } from '../components/Confirm/Confirm.state'
import { ActionName } from '../components/Actions'
import Card from '../components/Card'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import TableHorizontal, {
  TableHorizontalData,
  TableHorizontalHeader
} from '../components/TableHorizontal'
import Button from '../components/Button'
import HeadingRow from '../components/HeadingRow'

interface ContactsProps extends RouteComponentProps {}

interface ContactsState {
  contacts: TableHorizontalData<ContactData>[]
}

class Contacts extends Component<ContactsProps, ContactsState> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n("Name"), path: 'contactable.name' },
    { heading: i18n("Type"), path: 'contactableType' },
    { heading: i18n("Sites"), path: 'siteNames', breakable: true },
    { heading: i18n("Updated at"),
      path: 'contactable.updatedAt',
      date: true,
      tooltip: ['contactable.updatedUser.username']
    },
    { heading: i18n("Actions") }
  ]

  constructor (props: ContactsProps) {
    super(props)
    this.state = {
      contacts: []
    }
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleCreateClick () {
    this.props.history.push(routes.contactCreate)
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'edit') {
      const pathname = routes.contactEdit
      const state = { id }
      this.props.history.push({ pathname, state })
    } else if (action === 'delete') {
      const confirm: ConfirmParams = {
        id,
        type: 'warning',
        question: i18n('Are you sure to delete the contact?'),
        confirmText: i18n('Yes'),
        cancelText: i18n('No'),
        onConfirm: () => this.handleDeleteConfirm(id)
      }
      confirmService.push(confirm)
    }
  }

  handleDeleteConfirm (id: number) {
    contactApi.delete(id, contact => {
      if (!contact) return
      const contacts = contactService.delete(this.state.contacts, id)
      this.setState({ contacts })
    })
  }

  listContacts () {
    contactApi.list(contacts => {
      if (!contacts) return
      const contactsData = contactService.tableHorizontalData(contacts)
      this.setState({ contacts: contactsData })
    })
  }

  componentDidMount () {
    this.listContacts()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <Card>
            <HeadingRow
              heading={i18n("Contacts")}
              doc='contacts'>
              <Button
                text={i18n("Create")}
                onClick={this.handleCreateClick} />
            </HeadingRow>
            <TableHorizontal
              headers={this.headers}
              data={this.state.contacts}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(Contacts)
